import { LocalizationString } from '@celito.clients/assets';
import { ButtonTypes } from '@celito.clients/enums';
import { getCurriculumPageUrl } from '@celito.clients/utils';
import { Link } from 'react-router';

import { ColumnData, RowItem } from '../../../grid-view-new/src/types';
import { CustomButton } from '../../../shared';
import classes from '../reference-selector.module.css';

export const getCurriculumsSelectorGridColumns = (
  onItemDelete?: (item: RowItem) => void,
  isPreviewTab?: boolean,
  onColumnClick?: ColumnData['onColumnClick']
) => {
  const curriculumGridColumns: ColumnData[] = [
    {
      name: 'Curriculum ID',
      isResizable: true,
      key: 'label',
      maxWidth: 200,
      minWidth: 100,
      fieldName: 'label',
      onColumnClick,
      showSortIconWhenUnsorted: true,
      onRender: (item: RowItem) => (
        <Link
          to={getCurriculumPageUrl(item.name, item.version)}
          className={classes.hyperlink}
          target="_blank"
        >
          {item.label}
        </Link>
      ),
    },
    {
      name: 'Curriculum Version',
      isResizable: true,
      key: 'version',
      maxWidth: 120,
      minWidth: 100,
      fieldName: 'version',
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      name: 'Title',
      isResizable: true,
      key: 'title',
      maxWidth: 200,
      minWidth: 100,
      fieldName: 'title',
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      key: 'actions',
      minWidth: 75,
      maxWidth: 100,
      name: LocalizationString.ACTIONS,
      fieldName: 'actions',
      isResizable: true,
      onRender: (item?: RowItem, index?: number, column?: ColumnData) => (
        <CustomButton
          as="button"
          buttonType={ButtonTypes.Destructive}
          customStyles={classes.delete_btn}
          leftIcon="Delete"
          title="Delete"
          onClick={isPreviewTab ? undefined : () => onItemDelete?.(item!)}
          disabled={isPreviewTab}
        />
      ),
    },
  ];
  return curriculumGridColumns;
};
